import {Component, OnInit, Output, EventEmitter, OnDestroy, AfterViewInit, NgZone, ViewChild, ElementRef} from '@angular/core';
import {interval, Subscription} from "rxjs";
import {finalize} from "rxjs/operators";
import * as Communication from '../communication/index';
import {Router, ActivatedRoute} from '@angular/router';
import { Config } from '../../environments/environment';
import {ToolbarService} from "../shared/common/ToolbarEventService";
import {ToolbarEventPageEnum} from "../shared/common/ToolbarEvent";
import {ToolbarEvent} from "../shared/common/ToolbarEvent";
import {PaginationService} from "../shared/common/PaginationService";
import {PaginationEvent} from "../shared/common/PaginationEvent";
import {BulkOperationsService} from "../shared/common/BulkOperationsService";
import {BulkOperationsEvent} from "../shared/common/BulkOperationsEvent";
import {Authorization} from "../shared/authorization/authorization.component";
import {NavigationService} from "../shared/common/NavigationEventService";
import {NotificationService} from "../shared/common/NotificationService";
import {LoadingService} from "../shared/common/LoadingService";
import {NavigationEvent} from "../shared/common/NavigationEvent";
import {TranslateService} from '@ngx-translate/core';
import {count} from "rxjs";
import {MultiRequestResponseMessage} from "../communication/model/multiRequestResponseMessage";
import {Job} from "../communication/model/job";
import {HttpErrorResponse} from "@angular/common/http";


declare var $: any;
declare var sticky_custom: any;
declare var swal:any;

/**
 * This class represents the lazy loaded JobsComponent.
 */
@Component({
    selector: 'sd-jobs',
    templateUrl: 'jobs.component.html',
    styleUrls: ['jobs.component.css'],
    providers: [Communication.JobsService, Communication.TemplatesService, Communication.PublicLinkService, Communication.TagsService, Communication.DocumentsService, Communication.MultiRecipientRequestService, Communication.TeamService],
    standalone: false
})
export class JobsComponent implements OnInit, OnDestroy, AfterViewInit{

  tag:string;
  folder: string = "INBOX";
  status: string;
  keywords: string;
  sorting: string;
  smartstatus: string;
  start: number;
  limit: number;
  templateType:string;
  templateCategory:string;

  newLocation:string="";
  newLocationInnerHtml:string="";

  renamingTemplate:any = {};

  jobList: Communication.Job[];
  templateJobs: Communication.Job[];
  selectedJobIds = new Set<string>();

  get isAllSelected(): boolean {
    return this.jobList?.length > 0 && this.selectedJobIds.size === this.jobList.length;
  }

  get isIndeterminate(): boolean {
    return this.selectedJobIds.size > 0 && this.selectedJobIds.size < this.jobList?.length;
  }

  isSelected(jobId: number): boolean {
    return this.selectedJobIds.has(String(jobId));
  }
  subscriptions:Subscription[] = [];
  smartStatus:any={};
  paginationScalaTitle:string="";
  isPreActive:boolean=true;
  isNextActive:boolean=true;
  recordCount:number;
  resetKeywords:boolean=false; //default
  resetStatus:boolean=false;   //default
  resetSorting:string = "";    //created or updated sorting
  selectedItem:string="Inbox";
  jobRecipients:string=""; //popever data
  toogleSidebar:boolean=false;
  showTagDetails:boolean=false;
  tagList:Communication.UserTagList;
  isClickBlocked:boolean=false; //pre-next button double click fix

  templateId:number;
  jobIdForTemplate:number=null;
  templateUsage:string=""; //job or publicLink
  recipientGroups: Array<{orderNo: number, recipients: Communication.Recipient[]}> = [];
  widgets: Array<Communication.Recipient> = [];
  publicLinkItem:any = {};
  publicLinkItems:any= [];
  publicLinkItemError = "";
  fromWhere:string = "";
  publicLinkURL:string="";
  publicLinkReturnURL:string= '';
  publicLinkDescription:string= '';
  canCreatePublicLink:boolean= false;
  csvInputs:Array<Communication.Recipientfields>;
  updatedCVInputs:any=[];
  rowFields:any=[];
  csvFileName:string = "";
  csvFileErrMsg:string = "";
  csvFileSuccessMsg:string = "";

  uploadFile: any;
  // options:UploaderOptions = null;
  // uploadInput:EventEmitter<UploadInput>;
  uploadResponse:any;
  template:any = {};
  multiRequestCode:string = "";

  isTeamMember:boolean = false;

  @ViewChild('fileInput') fileInput: ElementRef;

  constructor(
    private jobsApi: Communication.JobsService,
    private multiRequestApi: Communication.MultiRecipientRequestService,
    private templatesApi: Communication.TemplatesService,
    private publiclinkApi: Communication.PublicLinkService,
    private tagsApi: Communication.TagsService,
    private documentsApi:Communication.DocumentsService,
    private activatedRoute: ActivatedRoute,
    private navigationService:NavigationService,
    private paginationService:PaginationService,
    private bulkOperationsService:BulkOperationsService,
    private router: Router,
    private toolbarService: ToolbarService,
    public authorization: Authorization,
    public notificationService: NotificationService,
    public translate: TranslateService,
    private zone:NgZone,
    private teamApi: Communication.TeamService,
    private loadingService: LoadingService
  ){

    // this.options = {
    //   concurrency:1,
    //   maxUploads:1,
    //   maxFileSize:1024*1024 // 1MB
    // }
    // this.uploadInput = new EventEmitter<UploadInput>();
  }


  ngOnInit() {
    if (!this.authorization.authenticated()) {
      this.router.navigate(['/']);

    } else {
      this.initLazyLoadVariable();

      this.subscriptions.push(this.navigationService.eventOccured$.subscribe(
        (event: NavigationEvent) => this.onNavigationEvent(event)
      ));

      this.toolbarService.action(new ToolbarEvent(ToolbarEventPageEnum.JOBS, "", null, "", "", "", "", "", ""));
      this.InitializeParams(this.selectedItem);
      this.UserJobSmartStatus();
      this.GetTheJobs(this.selectedItem);
      this.GetTags();
    }
  }

  initLazyLoadVariable() {
    //stop timer when initialize
    let timerSubscription = interval(500).subscribe(x => {

      if(this.authorization.userAccount !== null &&
        this.authorization.userAccount.hasOwnProperty("subscription") &&
        this.authorization.userAccount.subscription.hasOwnProperty("plan"))
      {
        if (timerSubscription != null)
          timerSubscription.unsubscribe();

        this.canCreatePublicLink = this.authorization.userAccount.subscription.plan.publicLink == 'Y';
      }
    });
  }


  InitializeParams(selectedItem:string){
    //reset UI elements
    this.ResetUI(selectedItem);

    if(this.selectedItem == "" || selectedItem == 'Inbox')
      this.folder = "INBOX";
    else if(selectedItem == 'Archive')
      this.folder = "ARCHIVE";
    else
      this.folder = "ALL";

    this.tag = "";
    this.status = "";
    this.keywords = "";
    this.sorting = "created";
    this.smartstatus = "";
    this.start = 0;
    this.limit = 10;
    if(Config.PAGE_LIMIT){
      this.limit = Config.PAGE_LIMIT;
    }
  }


  GetTheJobs(selectedItem:string){
    if(selectedItem !== 'Templates') {
      this.subscriptions.push(this.jobsApi.jobsGet(this.authorization.getAccessToken(), this.keywords, this.sorting, this.status, this.smartstatus, this.folder, this.tag, this.start.toString(), this.limit.toLocaleString()).subscribe(
        jobsResponse => {
          this.selectedItem = selectedItem;

          let dumpJobList: Communication.Job[] = jobsResponse.jobs;
          this.recordCount = jobsResponse.total;
          console.log("recordCount: " + this.recordCount);

          this.jobList = dumpJobList;
          this.selectedJobIds.clear();
          this.bulkOperationsService.action(new BulkOperationsEvent(false));

          this.isClickBlocked = false;
          this.PaginationActions();

        }, //Bind to view
        err => {
          // Log errors if any
          console.log(err);
          this.notificationService.displayError(err);
        }));

    } else {

      this.getTemplates(true);
    }

  }

  GetTags(){
    this.subscriptions.push(this.tagsApi.tagsGet(this.authorization.getAccessToken()).subscribe(
      (response:Communication.UserTagList) => {
        this.tagList = response;
        //console.log(response)
      },
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }

  showSelectedTag(selectedItem:Communication.UserTag){
    this.InitializeParams(selectedItem.name);
    this.tag = selectedItem.name;
    this.GetTheJobs(selectedItem.name);
  }

  PaginationActions(){
    //pagination label title e.g. 51-100
    let son = this.start + this.limit;
    if (son > this.recordCount ) son = this.recordCount;
    this.paginationScalaTitle = (this.start + 1) + " - " + son;

    //is previous button active
    if(this.start > 0)
      this.isPreActive = true;
    else
      this.isPreActive = false;

    //is next button active
    if(this.recordCount > this.start + this.limit)
      this.isNextActive = true;
    else
      this.isNextActive = false;

    this.paginationService.action(new PaginationEvent(this.paginationScalaTitle, this.isPreActive, this.isNextActive, this.resetKeywords, this.resetSorting, this.resetStatus, this.selectedItem));

    //return default setting after calling service
    this.resetKeywords = false;
    this.resetSorting = "";
    this.resetStatus = false;
  }


  UserJobSmartStatus(){
    this.subscriptions.push(this.jobsApi.jobsSmartstatusGet(this.authorization.getAccessToken()).subscribe(
      SmartStatusResponse => {
        this.smartStatus = SmartStatusResponse;
        console.log("UserJobSmartStatus ", SmartStatusResponse);
      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }));
  }



  ngAfterViewInit(){
    //sticky_custom.init();
    //myExtObject.func1();
  }


  public gotoJob(jobID: number){
    this.router.navigate(['/doc', jobID]);
  }

  public editTemplate(job: Communication.Job){
    // Navigate to appropriate template editing route based on job type
    if (job.type === 'SELF') {
      this.router.navigate(['/template-self', job.id]);
    } else {
      // For ME_OTHERS and other multi-recipient types
      this.router.navigate(['/template', job.id]);
    }
  }


  public refreshJob(isMultipleUpload: boolean){
      if(isMultipleUpload !== undefined && isMultipleUpload) {
        this.GetTheJobs(this.selectedItem);
      }
  }


  DefaultView(selectedItem:string){
    // get the default view for job list
    this.InitializeParams(selectedItem);
    this.GetTheJobs(selectedItem);
  }

  showSidebar(){
    this.toogleSidebar = !this.toogleSidebar;

    if(this.toogleSidebar)
      $('body').addClass('sidebar-mobile-main');
    else
      $('body').removeClass('sidebar-mobile-main');
  }


  private onNavigationEvent(event:NavigationEvent) {
    switch (event.acton) {
      case "FILTER_WITH_STATUS":
        this.FilterWithStatus(String(event.value));
        break;
      case "FILTER_WITH_SEARCH":
        this.FilterWithSearch(String(event.value));
        break;
      case "ORDER_BY":
        this.OrderBy(String(event.value));
        break;
      case "PRE_RECORDS":
        this.PreviousRecords();
        break;
      case "NEXT_RECORDS":
        this.NextRecords();
        break;
      case "BULK_OPERATION":
        this.bulkOperation(event.value);
        break;
      case "NEW_JOB_FROM_TEMPLATE":
        this.newJobFromTemplate(null);
        break;
      case "NEW_PUBLIC_LINK_FROM_TEMPLATE":
        this.newPublicLinkFromTemplate(null);
        break;
    }
  }

  newJobFromTemplate(job:Communication.Job){
    this.templateUsage = "job";


    if(job==null) {
      this.fromWhere='modal';
      this.getTemplates(false);
    } else {
      this.fromWhere='list';
      this.chooseTemplate(job);
    }
  }

  newPublicLinkFromTemplate(job:Communication.Job){
    if(!this.canCreatePublicLink){
      this.notificationService.showCurrentPlanNotSuitToDo(function (isConfirmed: boolean) {
        if (isConfirmed) {}
      })
    } else {
      this.templateUsage = "publicLink";

      if (job == null) {
        this.fromWhere = 'modal';
        this.getTemplates(false);
      } else {
        this.fromWhere = 'list';
        this.chooseTemplate(job);
      }
    }
  }


  applyTemplateToJobsAndSend(){
    this.templateUsage = "applyTemplateToJobsAndSend";

    this.fromWhere='modal';
    this.getTemplates(false);
  }

  bulkRequestwithCSV(job:Communication.Job){
    if(!this.canCreatePublicLink){
      this.notificationService.showCurrentPlanNotSuitToDo(function (isConfirmed: boolean) {
        if (isConfirmed) {}
      })
    } else {
      this.templateUsage = "bulkRequest";

      if (job == null) {
        this.fromWhere = 'modal';
        this.getTemplates(false);
      } else {
        this.fromWhere = 'list';
        this.chooseTemplate(job);
      }
    }
  }

  getTemplates(fromSidebar:boolean){
    this.templateType = "user";
    this.templateCategory = "all";

    this.subscriptions.push(this.jobsApi.templatesJobsGet(this.authorization.getAccessToken(), this.templateType, this.templateCategory).subscribe(
      (response: Communication.JoblistResult) => {
        let dumpJobList: Communication.Job[] = response.jobs;

        if(response.total > 0) {

          //TODO:this condition should be fixed to cover SELF
          if (this.templateUsage == "bulkRequest" ||
            this.templateUsage == "publicLink" ) {
            dumpJobList = response.jobs.filter((x: any) => x.type.toUpperCase() !== "SELF");
          }

          //copy object
          this.templateJobs = JSON.parse(JSON.stringify(dumpJobList));
          console.log("templateJobs: ", this.templateJobs);

        } else {
          this.templateJobs = [];
        }

        if (fromSidebar) {
          this.selectedItem = 'Templates';
          this.selectedJobIds.clear();
          this.recordCount = response.total;
          this.jobList = dumpJobList;
          this.isClickBlocked = false;
          this.PaginationActions();
        }

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }));
  }

  chooseTemplate(template:Communication.Job){
    this.templateId = template.id;
    this.publicLinkItems = [];

    if(this.jobIdForTemplate) { //apply template to job

      this.subscriptions.push(this.jobsApi.jobsIdTemplateTemplateIdPut(this.authorization.getAccessToken(), this.jobIdForTemplate, template.id).subscribe(
        (response: Communication.Job) => {
          console.log("template applied....");

          $('#templateJobs').modal('hide');

          let currentJobIndex:number = this.jobList.findIndex( x => x.id === this.jobIdForTemplate);
          if(currentJobIndex>-1) {
            this.jobList.splice(currentJobIndex, 1, response);

            this.notificationService.templateApplied();
          }

          //reset job selection
          this.jobIdForTemplate = null;
        }, //Bind to view
        err => {
          // Log errors if any
          console.log(err);
          if (err instanceof HttpErrorResponse) {
            let errorJson = err.error;
            if(errorJson.code == 276) { //incompatible api Version
              this.notificationService.showTemplateVersionConflict((isConfirmed: boolean) => {
                if (isConfirmed) {
                  $('#templateJobs').modal('hide');
                  // Navigate to template editor based on template type
                  if (template.type === 'SELF') {
                    this.router.navigate(['/template-self', template.id]);
                  } else {
                    this.router.navigate(['/template', template.id]);
                  }
                }
              });
              return;
            }
          }
          this.notificationService.displayError(err);
        }));

    } else {

      if(this.templateUsage == "job") { //create job from template

        this.subscriptions.push(this.jobsApi.jobsTemplateTemplateIdPost(this.authorization.getAccessToken(), template.id).subscribe(
          (response: Communication.Job) => {
            console.log("job created from template....");

            if(this.fromWhere == 'modal') {
              $('#templateJobs').modal('hide');

              if(this.selectedItem != 'Templates'){
                if(this.jobList == null){
                  this.jobList = [];
                  this.jobList.push(response)
                  this.recordCount++;
                } else {
                  this.jobList.splice(0, 0, response);
                  this.recordCount++;
                  //this.zone.run(() => {}); // or inject ChangeDetectorRef and call this.cdr.detectChanges();
                }
              }
            }

            this.notificationService.jobCreatedFromTemplate();

          }, //Bind to view
          err => {
            // Log errors if any
            console.log(err);
            if (err instanceof HttpErrorResponse) {
              let errorJson = err.error;
              if(errorJson.code == 276) { //incompatible api Version
                this.notificationService.showTemplateVersionConflict((isConfirmed: boolean) => {
                  if (isConfirmed) {
                    $('#templateJobs').modal('hide');
                    // Navigate to template editor based on template type
                    if (template.type === 'SELF') {
                      this.router.navigate(['/template-self', template.id]);
                    } else {
                      this.router.navigate(['/template', template.id]);
                    }
                  }
                });
                return;
              }
            }
            this.notificationService.displayError(err);
          }));

      } else if(this.templateUsage == "publicLink") {
        if(this.fromWhere == 'modal') {
          $('#templateJobs').modal('hide');
        }

        let cloneRecipients = JSON.parse(JSON.stringify(template.recipients));
        this.showRecipientOrderList(cloneRecipients);
        $("#newPublicLinkFromTemplate").modal('show');

      } else if(this.templateUsage == "bulkRequest") {
        this.getRecipientFields();

        if(this.fromWhere == 'modal') {
          $('#templateJobs').modal('hide');
        }

        let cloneRecipients = JSON.parse(JSON.stringify(template.recipients));
        this.showRecipientOrderList(cloneRecipients);

        $("#bulkRequestFromCSVModal").modal('show');

      } else if (this.templateUsage == "applyTemplateToJobsAndSend") {

        this.subscriptions.push(this.jobsApi.jobsTemplateTemplateIdPut(
          this.authorization.getAccessToken(),
          this.templateId,
          Array.from(this.selectedJobIds).join(',')
        ).subscribe(
          response => {
            console.log("Template applied to jobs");
            this.runAfterBulkOperation("ApplyTemplateAndSend");
          }, //Bind to view
          err => {
            // Log errors if any
            console.log(err);
            if (err instanceof HttpErrorResponse) {
              let errorJson = err.error;
              if(errorJson.code == 276) { //incompatible api Version
                this.notificationService.showTemplateVersionConflict((isConfirmed: boolean) => {
                  if (isConfirmed) {
                    $('#templateJobs').modal('hide');
                    // Navigate to template editor based on template type
                    if (template.type === 'SELF') {
                      this.router.navigate(['/template-self', template.id]);
                    } else {
                      this.router.navigate(['/template', template.id]);
                    }
                  }
                });
                return;
              }
            }
            this.notificationService.displayError(err);
          }
        ));
        $('#templateJobs').modal('hide');
      }




    }

    this.resetSelectedJobs();
  }

  trackByJobId(index: number, job: Communication.Job): number {
    return job.id;
  }

  linkCheckBoxChanged(checkboxValue:boolean, recipient:Communication.Recipient){
    this.publicLinkItem = { id: recipient.id, nick:'', citizenId: recipient.citizenId };

    if(checkboxValue){
      $("#nicknameModal").modal('show');
    } else {
      this.updateNick(false);
    }
  }


  updatePublicLinkRecipient(){
    let index = this.publicLinkItems.findIndex((x:any)=>x.nick==this.publicLinkItem.nick);
    if(index > -1) {
      //nickname already in use
      this.publicLinkItemError = this.translate.instant("Nickname is already in use. Please enter a different nickname");
    } else {
      this.publicLinkItemError = "";
      $("#nicknameModal").modal('hide');

      let index = this.publicLinkItems.findIndex((x: any) => x.id == this.publicLinkItem.id);

      if (index < 0) {
        this.publicLinkItems.push(this.publicLinkItem);

        //sort items
        this.publicLinkItems.sort((a:any, b:any)=> { return a.id - b.id } );

        if (this.templateUsage == "bulkRequest") {
          this.updateRecipientFields();
        }
      }

      this.updateNick(true);
      this.publicLinkItem = {};
    }
  }

  unSelectCheckBox(){
    this.publicLinkItemError = "";
    let id = "recipient_" + this.publicLinkItem.id;

    if(this.templateUsage == "bulkRequest"){
      $("#bulkRequestFromCSVModal #"+ id).attr('checked', false);
    } else {
      $("#"+ id).attr('checked', false);
    }
  }

  updateNick(checkBoxSelected:boolean){

    for(let i=0; i<this.recipientGroups.length; i++){
      for(let j=0;j<this.recipientGroups[i].recipients.length; j++)
      {
        if(this.recipientGroups[i].recipients[j].id == this.publicLinkItem.id){
          if(checkBoxSelected) {
            this.recipientGroups[i].recipients[j].name = this.publicLinkItem.nick;
            this.recipientGroups[i].recipients[j].email = "";
            this.recipientGroups[i].recipients[j].citizenId = "";
          } else {

            let templateJob = this.templateJobs.find(item=> item.id == this.templateId);

            if(templateJob){
              let recipients = templateJob.recipients;
              let recipient = recipients.find(item=>item.id == this.publicLinkItem.id);

              if(recipient){
                this.recipientGroups[i].recipients[j].name = recipient.name;
                this.recipientGroups[i].recipients[j].email = recipient.email;
                this.recipientGroups[i].recipients[j].citizenId = recipient.citizenId;

                let itemIndex = this.publicLinkItems.findIndex((x:any)=>x.id==this.publicLinkItem.id);
                if(itemIndex>-1) {
                  this.publicLinkItems.splice(itemIndex, 1);

                  if(this.templateUsage == "bulkRequest"){
                    this.updateRecipientFields();
                  }
                }
              }
            }

          }
        }

      }
    }

  }

  updateRecipientFields(){
    let radioGroup:any=[];
    this.updatedCVInputs = [];

    for(let i=0; i<this.csvInputs.length; i++){

      let recipient = { id: this.csvInputs[i].recipient.id, name: this.csvInputs[i].recipient.name };
      for(let item of this.publicLinkItems){
        if(recipient.id == item.id){
          recipient.name = item.nick
        }
      }

      let fieds = [];

      for(let field of this.csvInputs[i].fields){
        if(field.type!='radio'){
          let item = { id: field.id, text: field.variable};
          fieds.push(item);

        } else if(field.type=='radio' && radioGroup.indexOf(field.variable) == -1){
          let radioLabels:string = "";

          for(let _field of this.csvInputs[i].fields){
            if(_field.type=='radio' && _field.variable==field.variable) {
              if (radioLabels != "")
                radioLabels += "/";

              radioLabels += _field.label;
            }
          }

          let item = { id: field.id, text: field.variable + " ( " + radioLabels + " )"};
          fieds.push(item);

          radioGroup.push(field.variable);
        }
      }

      let recipientFields = {recipient: recipient, fields: fieds}
      this.updatedCVInputs.push(recipientFields);
    }

    //console.log("updatedCVInputs....... ", this.updatedCVInputs);
  }

  createPublicLink(){
    if(this.publicLinkItems.length == 0) {
      this.notificationService.changeOneorMoreRecipientFirst();
    } else {

      let id1:string, nick1:string, id2:string, nick2:string, id3:string, nick3:string, id4:string, nick4:string;

      id1 = this.publicLinkItems[0].id;
      nick1 = this.publicLinkItems[0].nick;

      if(this.publicLinkItems.length > 1 ){
        id2 = this.publicLinkItems[1].id;
        nick2 = this.publicLinkItems[1].nick;
      }
      if (this.publicLinkItems.length > 2){
        id3 = this.publicLinkItems[2].id;
        nick3 = this.publicLinkItems[2].nick;
      }

      if (this.publicLinkItems.length > 3){
        id4 = this.publicLinkItems[3].id;
        nick4 = this.publicLinkItems[3].nick;
      }

      this.subscriptions.push(this.publiclinkApi.publicLinkPost( this.authorization.getAccessToken(),String(this.templateId),  id1, nick1, this.publicLinkDescription, id2, nick2, id3, nick3, id4, nick4, this.publicLinkReturnURL).subscribe(
        (response: Communication.PublicLink) => {
          this.publicLinkURL = Config.WEB_APP_URL + "/doc-request/" + response.code;
          console.log("public link created.... ", this.publicLinkURL);

          this.publicLinkItems = [];
          this.publicLinkDescription = "";
          this.publicLinkReturnURL = "";

          $("#newPublicLinkFromTemplate").modal('hide');
          $("#publicLinkURL").modal('show');

          //this.notificationService.publicLinkCreated(this.publicLinkURL);

        }, //Bind to view
        err => {
          // Log errors if any
          console.log(err);
          this.notificationService.displayError(err);
        }));

    }

  }

  getRecipientFields(){
    this.subscriptions.push(this.templatesApi.templatesIdCsvInputsGet(this.authorization.getAccessToken(), String(this.templateId)).subscribe(
      (response: Array<Communication.Recipientfields>) => {
        //console.log("csv inputs.... ", response);
        this.csvInputs = response;
        this.updateRecipientFields();

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }));

  }

  /*
  templatesIdSampleCsvGet (accessToken: string, id: string, recipient1Id: string, recipient2Id?: string, recipient3Id?: string, recipient4Id?: string, extraHttpRequestParams?: any):Observable<any> {

    let queryParameters = new URLSearchParams();
    let headerParams = this.documentsApi.defaultHeaders;

    // verify required parameter 'accessToken' is not null or undefined
    if (accessToken === null || accessToken === undefined) {
      throw new Error('Required parameter accessToken was null or undefined when calling templatesIdSampleCsvGet.');
    }
    // verify required parameter 'id' is not null or undefined
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling templatesIdSampleCsvGet.');
    }
    // verify required parameter 'recipient1Id' is not null or undefined
    if (recipient1Id === null || recipient1Id === undefined) {
      throw new Error('Required parameter recipient1Id was null or undefined when calling templatesIdSampleCsvGet.');
    }
    if (recipient1Id !== undefined) {
      queryParameters.set('recipient1Id', String(recipient1Id));
    }

    if (recipient2Id !== undefined) {
      queryParameters.set('recipient2Id', String(recipient2Id));
    }

    if (recipient3Id !== undefined) {
      queryParameters.set('recipient3Id', String(recipient3Id));
    }

    if (recipient4Id !== undefined) {
      queryParameters.set('recipient4Id', String(recipient4Id));
    }

    headerParams.set('access_token', String(accessToken));

    let requestOptions:RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters,
      responseType: ResponseContentType.ArrayBuffer
    };

    return this.templatesApi.getHttp().request(path, requestOptions)
      .map((response:Response) => {
        if (response.status === 204) {
          return undefined;
        } else {
          return response;
        }
      });
  }
*/
  downloadSampleCSVFile(){
    console.log("publicLinkItems ", this.publicLinkItems)
    if(this.publicLinkItems.length == 0) {
      this.notificationService.changeOneorMoreRecipientFirst();
    } else {

      let id1: any, id2: any, id3: any, id4:any;

      id1 = this.publicLinkItems[0].id;

      if (this.publicLinkItems.length > 1) {
        id2 = this.publicLinkItems[1].id;
      }
      if (this.publicLinkItems.length > 2) {
        id3 = this.publicLinkItems[2].id;
      }

      if (this.publicLinkItems.length > 3) {
        id4 = this.publicLinkItems[3].id;
      }

      this.subscriptions.push(this.templatesApi.templatesIdSampleCsvGet(
        this.authorization.getAccessToken(),
        String(this.templateId),
        id1, id2, id3, id4,
        'response', // observe: 'response' to get full HttpResponse object
        false, // reportProgress
        { httpHeaderAccept: 'application/octet-stream' } // Force binary response
      ).subscribe(
        (response: any) => {
          console.log("file downloaded.... ");

          // response.body is the Blob
          const blob = response.body;
          const contentType = response.headers.get('Content-Type') || 'text/csv';

          // Create download link
          const url = window.URL.createObjectURL(blob);
          const linkElement = document.createElement('a');
          linkElement.setAttribute('href', url);
          linkElement.setAttribute("download", 'sample-file.csv');

          const clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);

          // Clean up the URL object
          window.URL.revokeObjectURL(url);

        },
        (err: HttpErrorResponse) => {
          // Handle errors - check if it's a JSON error message
          console.log(err);

          // If error body is a Blob, try to parse it as JSON
          if (err.error instanceof Blob && err.error.type === 'application/json') {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorResponse = JSON.parse(reader.result as string);
                console.log('Error response:', errorResponse);
                // You can display the error message from errorResponse.message if needed
              } catch (e) {
                console.log('Could not parse error response');
              }
            };
            reader.readAsText(err.error);
          }

          this.notificationService.errorDurindCSFFileDownload();
        }));
    }
  }

  onCSVFileSelected(event: any) {
    const file = event.target.files[0];

    if (file) {
      // Reset error messages
      this.csvFileErrMsg = "";
      this.csvFileSuccessMsg = "";

      // Set the file name
      this.csvFileName = file.name;

      // Validate file size (max 10MB)
      if (file.size > 10 * 1024 * 1024) {
        this.csvFileErrMsg = this.translate.instant("Dosya boyutu en fazla 10MB olabilir.");
        this.csvFileName = "";
        return;
      }

      // Validate file type
      const match = (/\.(csv)$/i).test(file.name);
      if (!match) {
        this.csvFileErrMsg = this.translate.instant("Dosya tipi *.csv olmalıdır.");
        this.csvFileName = "";
        return;
      }

      // Store the file for upload
      this.uploadFile = file;
    }
  }

  browseUploaderFile(file:any){
    if(this.publicLinkItems.length == 0) {
      this.notificationService.changeOneorMoreRecipientFirst();
    } else {
      this.initUploader();
      file.click();
    }
  }

  initUploader() {
    //reset existing
    this.uploadFile = null;
    this.uploadResponse = null;
  }

  onUploadOutput(output: any/*UploadOutput*/) {
    /*
    switch (output.type) {
      case 'addedToQueue':{
        console.log("addedToQueue",output)
        if (typeof output.file !== 'undefined') {
          this.onFileChange(output.file)
        }
      } break;
      case 'uploading':{
        console.log("uploading",output)
        if (typeof output.file !== 'undefined') {
          this.uploadFile = output.file
        }
      } break;
      case 'done':{
        console.log("done")
        if (output.file && output.file.response) {
          console.log("uploadResponse",output)
          this.uploadResponse = output.file.response;

          //if error occurs
          if (this.uploadResponse.hasOwnProperty('code')) {
            console.log("response " + this.uploadResponse.description);
            let language = this.translate.currentLang;
            if(this.uploadResponse.code == 200) {
              this.csvFileSuccessMsg = this.translate.instant("The file has been successfully uploaded.");
              this.notificationService.signingRequestSent();
              this.uploadInput.emit({type:"cancelAll"})
              // Clear CSV file to disable OK button after successful upload
              this.csvFileName = "";
              this.uploadFile = null;
              this.uploadResponse = null;
            } else if(this.uploadResponse.code == 203 || this.uploadResponse.code == 234 || this.uploadResponse.code == 299) {
              this.csvFileErrMsg = this.translate.instant(this.uploadResponse.description);
              this.uploadInput.emit({type:"cancelAll"})
            } else if(language=='tr') {
              if(this.uploadResponse.code == 297){
                let params = this.uploadResponse.description.split("line");
                this.csvFileErrMsg = params[1] + ". satırdaki kolon sayısı uygun değil";
              } else if(this.uploadResponse.code == 298){
                let params = this.uploadResponse.description.split(" has an unceptable value at line ");
                this.csvFileErrMsg = params[1] + ". satırdaki '" + params[0] + "' kolon verisi geçersiz";
              }
              this.uploadInput.emit({type:"cancelAll"})
            } else {
              this.csvFileErrMsg = this.uploadResponse.description;
              this.uploadInput.emit({type:"cancelAll"});
            }
          }
        }
        this.uploadInput.emit({type:"removeAll"})
      } break;
      case 'rejected':{
        console.log("rejected",output)
        this.uploadInput.emit({type:"removeAll"})
        this.uploadFile = null;
        this.uploadResponse = null;
        if (output.file.size > 1024*1024) {
          this.csvFileErrMsg = this.translate.instant("Dosya boyutu en fazla 10MB olabilir.");
        } else if (!(/\.(gif|jpg|jpeg|png|pdf)$/i).test(output.file.name)){
          this.csvFileErrMsg = this.translate.instant("Dosya tipi *.csv olmalıdır.");
        }
      } break;
      case "removedAll":{
        console.log("removedAll",output)
      } break;
      case "cancelled":{
        this.uploadFile = null;
        this.uploadResponse = null;
      } break;
    }*/
  }

  resetCSVFileVariables() {
    this.csvFileName = "";
    this.csvFileErrMsg = "";
    this.csvFileSuccessMsg = "";
  }

  onFileChange(uploadedFile: any/*UploadFile*/) {
    this.resetCSVFileVariables();

    if(uploadedFile && uploadedFile.size > 0) {

      this.csvFileName = uploadedFile.name;

      if (uploadedFile.size > 10*1024*1024) {
        //this.uploadInput.emit({type:"cancelAll"})
        this.csvFileErrMsg = this.translate.instant("Dosya boyutu en fazla 10MB olabilir.");
      }

      let match:any = (/\.(csv)$/i).test(uploadedFile.name);
      console.log("file type match: " + match);

      if (!match) {
        if (this.csvFileErrMsg){
          this.csvFileErrMsg = this.translate.instant("Dosya boyutu en fazla 10MB ve tipi *.csv olmalıdır.");
        } else {
          this.csvFileErrMsg = this.translate.instant("Dosya tipi *.csv olmalıdır.");
        }
        //this.uploadInput.emit({type:"cancelAll"})
      }
    }
  }

  startUpload() {
    if (!this.uploadFile) {
      return;
    }

    if (this.publicLinkItems.length == 0) {
      this.notificationService.changeOneorMoreRecipientFirst();
      return;
    }

    // Reset messages
    this.csvFileErrMsg = "";
    this.csvFileSuccessMsg = "";

    // Get recipient IDs
    let id1 = this.publicLinkItems[0].id;
    let id2 = this.publicLinkItems.length > 1 ? this.publicLinkItems[1].id : undefined;
    let id3 = this.publicLinkItems.length > 2 ? this.publicLinkItems[2].id : undefined;
    let id4 = this.publicLinkItems.length > 3 ? this.publicLinkItems[3].id : undefined;

    // Show button loading spinner
    this.loadingService.showButtonSpinner('csv-upload');

    // Upload the CSV file
    this.subscriptions.push(
      this.templatesApi.jobsCsvPost(
        this.authorization.getAccessToken(),
        String(this.templateId),
        id1,
        this.uploadFile,
        id2,
        id3,
        id4
      ).pipe(
        finalize(() => {
          // Hide button loading spinner when done (success or error)
          this.loadingService.hideButtonSpinner('csv-upload');
        })
      ).subscribe(
        (response: Communication.ResponseMessage) => {
          if (response.code == 200) {
            this.csvFileSuccessMsg = this.translate.instant("The file has been successfully uploaded.");
            this.notificationService.signingRequestSent();

            // Clear the file input after successful upload
            this.csvFileName = "";
            this.uploadFile = null;
            this.uploadResponse = null;

            // Reset the file input element to allow selecting the same file again
            if (this.fileInput && this.fileInput.nativeElement) {
              this.fileInput.nativeElement.value = '';
            }
          } else {
            // Handle non-200 success codes
            this.csvFileErrMsg = this.translate.instant(response.message || "An error occurred during upload.");
          }
        },
        (err: HttpErrorResponse) => {
          // Try to extract error message
          let errorMessage = "An error occurred during file upload.";

          if (err.error && err.error.message) {
            errorMessage = err.error.message;
          } else if (err.message) {
            errorMessage = err.message;
          }

          this.csvFileErrMsg = this.translate.instant(errorMessage);
        }
      )
    );
  }


  showRecipientOrderList(recipients: Array<Communication.Recipient>): void {
    this.recipientGroups = [];

    // Input validation
    if (!recipients || recipients.length === 0) {
      console.warn('showRecipientOrderList: No recipients provided');
      return;
    }

    // Group recipients by orderno using a Map for O(n) performance
    const recipientMap = new Map<number, Communication.Recipient[]>();

    recipients.forEach(recipient => {
      // Convert orderno to number, default to 0 if invalid
      const orderNumber = this.parseOrderNumber(recipient.orderno);

      if (!recipientMap.has(orderNumber)) {
        recipientMap.set(orderNumber, []);
      }
      recipientMap.get(orderNumber)!.push(recipient);
    });

    // Sort order numbers and create groups (only for non-empty groups)
    const sortedOrders = Array.from(recipientMap.keys()).sort((a, b) => a - b);

    sortedOrders.forEach(orderNo => {
      const recips = recipientMap.get(orderNo);
      if (recips && recips.length > 0) {
        this.recipientGroups.push({
          orderNo: orderNo,
          recipients: recips
        });
      }
    });

    console.log(`Created ${this.recipientGroups.length} recipient groups from ${recipients.length} recipients`);
  }

  // Helper method to safely parse orderno
  private parseOrderNumber(orderno: string | number | undefined | null): number {
    if (orderno === undefined || orderno === null || orderno === '') {
      return 0; // Default to 0 for missing/invalid values
    }

    const parsed = Number(orderno);
    return isNaN(parsed) ? 0 : Math.max(0, Math.floor(parsed)); // Ensure non-negative integer
  }

  updateJobSelectionList(jobId: number, isChecked: boolean) {
    const id = String(jobId);
    if (isChecked) {
      this.selectedJobIds.add(id);
    } else {
      this.selectedJobIds.delete(id);
    }
    this.bulkOperationsService.action(new BulkOperationsEvent(this.selectedJobIds.size > 0));
  }

  public selectAll(isChecked: boolean) {
    this.selectedJobIds.clear();
    if (isChecked) {
      this.jobList.forEach(item => this.selectedJobIds.add(String(item.id)));
    }
    this.bulkOperationsService.action(new BulkOperationsEvent(this.selectedJobIds.size > 0));
  }

  public bulkOperation(operation:string){
    if(operation=="Download"){
      if(this.authorization.userAccount.subscription.plan.multipleFiles == 'Y') {
        this.runBulkOperation(operation);
      } else{
        let self = this;
        this.notificationService.showCurrentPlanNotSuitToDo(function (isConfirmed: boolean) {
          if (isConfirmed) {
            self.selectedJobIds.clear();
            self.bulkOperationsService.action(new BulkOperationsEvent(false));
          }
        })
      }

    }
    else if(operation == "ApplyTemplateAndSend" || operation == "BulkSign") {
      this.runBulkOperation(operation);
    }
    else {
      let self = this;
      this.notificationService.showBulkOperationAlert(operation, function (isConfirmed: boolean) {
        if (isConfirmed) {
          self.runBulkOperation(operation);
        } else {
          self.selectedJobIds.clear();
          self.bulkOperationsService.action(new BulkOperationsEvent(false));
        }
      })
    }

  }

  runBulkOperation(operation:string){
      if(operation=="Archive"){
        this.subscriptions.push(this.jobsApi.jobsBulkactionsArchivePut(
          this.authorization.getAccessToken(),
          Array.from(this.selectedJobIds).join(','),
        ).subscribe(
          response => {
            console.log("Bulk move to archive operation completed...");
            this.runAfterBulkOperation(operation);
          }, //Bind to view
          err => {
            // Log errors if any
            console.log(err);
            this.notificationService.displayError(err);
          }));
      }

      else if(operation=="Move to Inbox"){
        this.subscriptions.push(this.jobsApi.jobsBulkactionsMovetoinboxPut(
          this.authorization.getAccessToken(),
          Array.from(this.selectedJobIds).join(','),
        ).subscribe(
          response => {
            console.log("Bulk move to inbox operation completed...");
            this.runAfterBulkOperation(operation);
          }, //Bind to view
          err => {
            // Log errors if any
            console.log(err);
            this.notificationService.displayError(err);
          }));
      }

      else if(operation=="Delete"){
        if(this.selectedItem == "Templates"){
          this.subscriptions.push(
            this.templatesApi.jobsBulkactionsDeletetemplateDelete(
              this.authorization.getAccessToken(),
              Array.from(this.selectedJobIds).join(',')
            ).subscribe(
              response => {
                console.log("Bulk delete template operation completed")
                this.runAfterBulkOperation(operation);
              },
              error => {
                console.log(error);
                this.notificationService.displayError(error);
              }
            )
          )
        } else {
          this.subscriptions.push(
            this.jobsApi.jobsBulkactionsDeleteDelete(
              this.authorization.getAccessToken(),
              Array.from(this.selectedJobIds).join(','),
            ).subscribe(
              response => {
                console.log("Bulk delete operation completed...");
                this.runAfterBulkOperation(operation);
              }, //Bind to view
              err => {
                // Log errors if any
                console.log(err);
                this.notificationService.displayError(err);
              }
            )
          );
        }
      }
      else if(operation=="BulkSign"){

        this.subscriptions.push(this.multiRequestApi.multirecipientrequestsPost(
          this.authorization.getAccessToken(),
          Array.from(this.selectedJobIds).join(','),
          this.authorization.userProfile.name,
          this.authorization.userProfile.email
        ).subscribe(
          response => {
            console.log("Bulk signing request created");
            this.multiRequestCode = response.multiRequestCode;
            this.runAfterBulkOperation(operation);
          }, //Bind to view
          err => {
            // Log errors if any
            console.log(err);
            this.notificationService.displayError(err);
          }));
      }

      else if(operation=="ApplyTemplateAndSend"){

        this.applyTemplateToJobsAndSend();

      }
      else if(operation=="Download"){
        console.warn(operation, this.selectedJobIds);

        let hasNonCompleted = false;
        this.selectedJobIds.forEach(item => {
          let job:any = this.jobList.find(function(job) { return job.id == Number(item); });
          if (job === undefined || job.status !== 'COMPLETED') {
            hasNonCompleted = true;
          }
        });
        if (hasNonCompleted) {
          this.notificationService.allJobsMustBeCompleted();
          return;
        }

        let docIds:string[] = [];
        this.selectedJobIds.forEach(item => {
          let job:any = this.jobList.find(function(job) { return job.id == Number(item); });

          if(job !== undefined)
            docIds.push(job.documents[0].id);
        });

        let name = new Date().toLocaleString() + ".zip";

        this.subscriptions.push(this.documentsApi.documentsDownloadGet(this.authorization.getAccessToken(), String(docIds), false ).subscribe(
          (data: Blob) => {
            console.log("Bulk download operation completed...");
            this.notificationService.documentDownloadStarted(name);
            this.runAfterBulkOperation(operation);

            // Data is already a Blob, use it directly
            let url = window.URL.createObjectURL(data);
            let linkElement = document.createElement('a');

            linkElement.setAttribute('href', url);
            linkElement.setAttribute("download", name);

            let clickEvent = new MouseEvent("click", {
              "view": window,
              "bubbles": true,
              "cancelable": false
            });
            linkElement.dispatchEvent(clickEvent);

            // Clean up blob URL after download
            setTimeout(() => window.URL.revokeObjectURL(url), 100);
          },
          (err:any) => {
            this.notificationService.displayError(err);
          }
        ));
      }
  }

  resetSelectedJobs() {
    this.selectedJobIds.clear();
    this.GetTheJobs(this.selectedItem);
  }

  runAfterBulkOperation(operation:string){
    this.notificationService.bulkOperationCompleted(operation);
    this.bulkOperationsService.action(new BulkOperationsEvent(this.selectedJobIds.size > 0));
    this.resetSelectedJobs();
    if(operation=="Delete") {
      this.GetTags(); //refresh tags
      this.UserJobSmartStatus() // refresh smart status
    } else if(operation=="BulkSign") {
      //navigate to multisigning
      this.router.navigate(['/multisign', this.multiRequestCode]);
      this.multiRequestCode = "";
    } else if(operation=="") {
      this.GetTags(); //refresh tags
      this.UserJobSmartStatus() // refresh smart status
    }


  }

  public FilterWithStatus(status: string){
    this.ResetPreNext();
    if(status == "ALL")
      this.status = "";
    else{
      this.status = status;}

    this.GetTheJobs(this.selectedItem);
  }


  public FilterWithSearch(keywords: string){
    this.ResetPreNext();
    this.keywords = keywords;
    if(keywords.length <= 1){
      this.notificationService.searchFilterNotSuitable();
      return;
    }
    this.GetTheJobs(this.selectedItem);
  }


  public OrderBy(sorting: string){
    this.sorting = sorting;
    this.GetTheJobs(this.selectedItem);
  }

  public PreviousRecords(){
    if(!this.isClickBlocked) {
      if (this.start > this.limit)
        this.start -= this.limit;
      else
        this.start = 0;

      this.isClickBlocked = true;

      this.GetTheJobs(this.selectedItem);
      this.goToTopOfPage();
    }
  }

  public NextRecords(){
    if(!this.isClickBlocked) {
      if(this.recordCount > this.start + this.limit)
        this.start += this.limit;

      this.isClickBlocked = true;

      this.GetTheJobs(this.selectedItem);
      this.goToTopOfPage();
    }
  }

  private goToTopOfPage(){
    //show top on the page
    $(document).ready(function(){
      $(this).scrollTop(0);
    });
  }

  public showSmartStatus(selectedItem:string){
    this.InitializeParamsForSmartStatus();

    this.smartstatus = "waitingme";
    if(selectedItem == "Waiting For Others")
      this.smartstatus = "waitingothers";
    if(selectedItem == "Completed")
      this.smartstatus = "completed";
    if(selectedItem == "My Jobs")
      this.smartstatus = "myjobs";

    this.GetTheJobs(selectedItem);
  }

  InitializeParamsForSmartStatus(){
    //reset UI elements
    this.ResetUI("Smart Status");

    this.tag = "";
    this.folder = "ALL";
    this.status = "";
    this.keywords = "";
    this.sorting = "updated";
    this.start = 0;
    this.limit = 10;
    if(Config.PAGE_LIMIT){
      this.limit = Config.PAGE_LIMIT;
    }
  }

  ResetUI(item:string){
    if(this.keywords != "")
      this.resetKeywords=true;

    if(this.status != "")
      this.resetStatus=true;

    // dafault: sort creation date,
    // smart status: sort updated
    if(item== "" || item=="All Documents" || item=="Inbox" || item=="Archive")
      this.resetSorting="created";
    else if(item=="Smart Status")
      this.resetSorting = "updated";
  }

  ResetPreNext(){
    this.start = 0;
    this.limit = 10;
    if(Config.PAGE_LIMIT){
      this.limit = Config.PAGE_LIMIT;
    }
  }



  //<--- DELETE JOB --->
  public DeleteJob(jobId:number, jobName:string) {
    let _thisDelete=this;
    let removeItem = this.selectedItem != 'Templates' ? 'job' : 'template';

    this.notificationService.showJobDeleteAlert(removeItem, function(isConfirmed:boolean) {
      if (isConfirmed){

        // setTimeout(function () { //silme işlemi sonrası  alert tetiklenmediği için 1 sn gecikme ekledik
          _thisDelete.subscriptions.push(_thisDelete.jobsApi.jobsIdDelete(_thisDelete.authorization.getAccessToken(), jobId).subscribe(
            (response: any) => {
              if (response.code == 200) {
                _thisDelete.notificationService.jobDeleted(jobName);
                _thisDelete.GetTheJobs(_thisDelete.selectedItem); //refresh jobs
                _thisDelete.GetTags(); //refresh tags
                _thisDelete.UserJobSmartStatus() // refresh smart status
              }
            },
            (err: any) => {
              // Log errors if any
              console.log(err);
              //_thisDelete.DeleteFailureAlert();
              _thisDelete.notificationService.displayError(err);
            }
          ));
      //  }, 1000);
    }

    });
  }

  // Rename Template
  public renameTemplate(){
    let _thisRename=this;
    //let renameItem = this.newTemplate;


    _thisRename.subscriptions.push(
      _thisRename.templatesApi.templatesJobIdRenamePut(
        _thisRename.authorization.getAccessToken(),
        _thisRename.renamingTemplate.id,
        _thisRename.renamingTemplate.name
      ).subscribe(
        (response: any) => {
          _thisRename.notificationService.templateRenamed();
          _thisRename.GetTheJobs(_thisRename.selectedItem); //refresh jobs
          _thisRename.GetTags(); //refresh tags
          _thisRename.UserJobSmartStatus(); // refresh smart status
        },
        (err: any) => {
          // Log errors if any
          console.log(err);
          //_thisDelete.DeleteFailureAlert();
          _thisRename.notificationService.displayError(err);
        }
      )
    );

  }

  //<--- DELETE JOB --->

  // Delete Template
  public deleteTemplate(jobId:number, jobName:string){
    let _thisDelete=this;
    let removeItem = this.selectedItem != 'Templates' ? 'job' : 'template';
    this.notificationService.showJobDeleteAlert(removeItem, function(isConfirmed:boolean) {
      if(isConfirmed){
        _thisDelete.subscriptions.push(
          _thisDelete.templatesApi.templatesIdDelete(
            _thisDelete.authorization.getAccessToken(),
            jobId
          ).subscribe(
            (response: any) => {
              _thisDelete.notificationService.jobDeleted(jobName);
              _thisDelete.GetTheJobs(_thisDelete.selectedItem); //refresh jobs
              _thisDelete.GetTags(); //refresh tags
              _thisDelete.UserJobSmartStatus() // refresh smart status
            },
            (err: any) => {
              // Log errors if any
              console.log(err);
              //_thisDelete.DeleteFailureAlert();
              _thisDelete.notificationService.displayError(err);
            }
          )
        )
      }
    });
  }


  locationSettings(job:Communication.Job) {
    let location: string = "";

    //owner of job
    if (this.authorization.userProfile.email == job.user.email) {
      location = job.location;
    } else {
      //signer of job
      for (let recipient of job.recipients) {
        if (this.authorization.userProfile.email == recipient.email) {
            location = recipient.jobLocationForRecipient;
        }
      }
    }

    if(location == "Inbox" || location == "INBOX") {
      this.newLocation = "Archive";
      this.newLocationInnerHtml = '<i class="icon-folder-download3"></i>' + this.translate.instant(this.newLocation);
    }
    else if(location == "Archive" || location == "ARCHIVE"){
      this.newLocation = "Move to Inbox";
      this.newLocationInnerHtml = '<i class="icon-inbox-alt"></i>' + this.translate.instant(this.newLocation);
    }
  }


  scrollDown(target:any){
    // for to see last two dropdown menu items
    $('.datatable-scroll-wrap').animate({
      scrollTop: target.offsetTop + 150
    }, 100);
  }

  setLocation(job:Communication.Job){
    if(this.newLocation =="Move to Inbox")
      this.moveToInbox(job);
    else if(this.newLocation =="Archive")
      this.moveToArchive(job);
  }


  moveToArchive(job:Communication.Job){
    this.subscriptions.push(this.jobsApi.jobsIdMovetoarchivePut(this.authorization.getAccessToken(), job.id).subscribe(
      (response:Communication.Job) => {

        this.GetTheJobs(this.selectedItem);
        console.log("response " + response.location);
        this.notificationService.jobMovedToArchive(job.name);
        /*let index = this.jobList.indexOf(job);
         this.jobList[index] = response;

         console.log("index " + index);
         console.log("response " + response);
         console.log("this.jobList[index] " + this.jobList[index]);*/

      },
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }

  moveToInbox(job:Communication.Job){
    this.subscriptions.push(this.jobsApi.jobsIdMovetoinboxPut(this.authorization.getAccessToken(), job.id).subscribe(
      (response:Communication.Job) => {

        this.GetTheJobs(this.selectedItem);
        console.log("response " + response.location);
        this.notificationService.jobMovedToInbox(job.name);

        /*let index = this.jobList.indexOf(job);
        this.jobList[index] = response;

        console.log("index " + index);
        console.log("response " + response);
        console.log("this.jobList[index] " + this.jobList[index]);*/

      },
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }



  public downloadDocument(id:number, name:string, variation: 'original' | 'signed') {
      let reader = new FileReader();
      this.notificationService.documentDownloadStarted(name);

      this.subscriptions.push(this.documentsApi.documentsIdDownloadGet(this.authorization.getAccessToken(), id, variation).subscribe(
        (data:any) => {
          // If data is a Blob or ArrayBuffer
          let blob: Blob;
          if (data instanceof Blob) {
            blob = data;
          } else if (data instanceof ArrayBuffer) {
            blob = new Blob([data], { type: 'application/pdf' });
          } else if (data && data.body) {
            blob = new Blob([data.body], { type: 'application/pdf' });
          } else {
            console.error('Unknown data format for download');
            return;
          }

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);

        },
        (err:any) => {
          // Log errors if any
          console.log(err);
          this.notificationService.documentNotFound();
        }
      ));
      reader.onloadend = function (e) {
        window.open(reader.result.toString(), "_blank");
      }
    }

  createTemplateModal(jobId:number){
    this.template.jobId = jobId;

    if(this.authorization.userProfile.email == "info@imzayeri.com") {
      $('#createTemplate').modal('show');
    } else {
      this.createTemplate();
    }

  }

  createTemplate() {
    let category:string = this.template.category || "default";

    this.subscriptions.push(this.jobsApi.templateJobIdPost(this.authorization.getAccessToken(), this.template.jobId, category, this.template.definition).subscribe(
      (response:any) => {
        console.log("Şablon oluşturuldu.");
        $('#createTemplate').modal('hide');
        this.template={};

        this.notificationService.templateCreated();
      },
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
        $('#createTemplate').modal('hide');
      }
    ));
  }

  mouseOver(recipients:any){
    this.jobRecipients = "";

    for (let recipient of recipients) {
       this.jobRecipients += recipient.name + '<br>';
   }
    //prepare to run
    this.InitializePopover();
 }


  InitializePopover(){
    $('#recipientList').popover({
      title: 'All Recipients',
      content: this.jobRecipients,
      html: true,
      trigger: 'click'
    });
  }

  /**
   * Check if the job's API version doesn't match the current API version
   * Used to display warning for templates with old coordinate system
   */
  isApiVersionMismatch(job: Communication.Job): boolean {
    return job.apiVersion != null && job.apiVersion !== Config.API_VERSION;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(
      (s: Subscription) => s.unsubscribe()
    );
  }

}
